import React from "react";
import { Container } from "react-bootstrap";
import "./OtherBusinesses.css";

const OtherBusinesses = () => {
  return (
    <section className="other-business-page">
      <Container>

        <h1 className="other-business-title">
          Group Diversification & Associate Ventures
        </h1>

        <h2 className="other-business-subtitle">
          Diversified Leadership with Long-Term Business Foundations
        </h2>

        <p>
          At Plenary Holidays, our leadership’s vision extends beyond the travel and MICE domain. Over the years, the Directors have developed structured interests in agriculture and allied sectors, reflecting financial prudence, operational discipline, and long-term enterprise building.
        </p>

        <p>
          These diversified ventures are managed with a focus on sustainability, quality control, and responsible business practices—principles that also guide the functioning of Plenary Holidays.
        </p>

        <h3 className="other-business-section">
          1. Sustainable Horticulture & Orchard Management
        </h3>

        <p>
          The Directors oversee agricultural land spanning approximately 30 acres in Haryana, India, dedicated to structured fruit cultivation.
        </p>

        <p>
          The orchards combine traditional agricultural knowledge with modern cultivation practices, focusing on:
        </p>

        <ul>
          <li>Selected varieties of Mango, Guava, and Peach</li>
          <li>Premium seasonal produce</li>
          <li>Controlled-input farming methods</li>
          <li>Soil and crop sustainability planning</li>
        </ul>

        <p>
          Certain varieties are cultivated with attention to low-sugar profiles and improved nutritional value, catering to evolving market preferences.
        </p>

        <p>
          The emphasis remains on consistent quality, responsible land management, and long-term agricultural viability rather than rapid scale expansion.
        </p>

        <h3 className="other-business-section">
          2. Organized Poultry Operations
        </h3>

        <p>
          With a focus on hygienic and regulated production standards, the Directors have established a poultry operation managed under structured biosecurity and health monitoring systems.
        </p>

        <p>
          Current operational capacity: approximately 40,000 birds.
        </p>

        <p>The facility operates with:</p>

        <ul>
          <li>Disease-control protocols</li>
          <li>Controlled feed and mineral regulation</li>
          <li>Monitored health systems</li>
          <li>Clean and organized production infrastructure</li>
        </ul>

        <p>
          The objective is to maintain consistent quality standards while adhering to responsible livestock management practices.
        </p>

        <h3 className="other-business-section">
          3. Premium Rice Trading & Milling
        </h3>

        <p>
          The Directors are also engaged in rice trading and milling operations supported by leased infrastructure and systematic processing standards.
        </p>

        <p>The business focuses on:</p>

        <ul>
          <li>Premium long-grain Basmati rice</li>
          <li>Selected aromatic rice varieties</li>
          <li>Consistent sourcing and quality monitoring</li>
          <li>Structured procurement and distribution channels</li>
        </ul>

        <p>
          Modern milling and sorting processes are utilized to maintain grain integrity and product consistency.
        </p>

        <p>
          The trading operations serve both domestic markets and bulk institutional requirements with a disciplined commercial framework.
        </p>

        <h3 className="other-business-section">
          Responsible & Structured Growth
        </h3>

        <p>
          All associated ventures operate within appropriate regulatory frameworks and lawful registrations.
        </p>

        <p>The leadership philosophy across sectors remains consistent:</p>

        <ul>
          <li>Ethical business conduct</li>
          <li>Transparent financial practices</li>
          <li>Long-term asset development</li>
          <li>Sustainable operational planning</li>
          <li>Measured and disciplined growth</li>
        </ul>

        <h3 className="other-business-section">
          Strength Through Stability
        </h3>

        <p>
          The diversified interests of the Directors reflect asset-backed stability and multi-sectoral experience.
        </p>

        <p>
          This broader exposure to agriculture, supply chains, and structured operations enhances governance discipline and long-term financial stability—qualities that strengthen the foundation of Plenary Holidays as a professionally managed Travel Management Company.
        </p>

      </Container>
    </section>
  );
};

export default OtherBusinesses;